<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row dense>
          <v-col
            v-for="skill in items"
            :key="skill.id"
            cols="12"
            sm="6"
            md="4"
            class="d-flex align-items-stretch"
          >
            <v-card variant="flat" class="my-4 flex-grow-1 app-content-card">
              <v-card-text class="text-left">
                <h3>{{ $t("candidateTabs.skills.field") }}: {{ skill.Skill }}</h3>
                <v-divider></v-divider>
                <p>
                  <strong>{{ $t("candidateTabs.skills.main") }}:</strong>
                  {{ skill.Main_skill ? $t("candidates.values.yes") : $t("candidates.values.no") }}
                </p>
                <p><strong>{{ $t("candidateTabs.skills.level") }}:</strong> {{ skill.Level }}</p>
              </v-card-text>
              <v-card-actions>
                <v-btn icon @click="openEditSkillDialog(skill)">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="confirmDeleteSkill(skill.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-btn
          color="primary"
          @click="openAddSkillDialog"
          class="mb-4 d-flex align-items-stretch"
        >
          {{ $t("candidateTabs.skills.addButton") }}
        </v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addSkillDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ $t("candidateTabs.skills.addTitle") }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="addSkill">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field :label="`${$t('candidateTabs.skills.field')} *`" v-model="newSkill.Skill" :rules="[rules.required]" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select :items="yesNoOptions" item-title="title" item-value="value" :label="$t('candidateTabs.skills.mainQuestion')" v-model="newSkill.Main_skill" :rules="[rules.required]" outlined required></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field :label="`${$t('candidateTabs.skills.level')} *`" v-model="newSkill.Level" :rules="[rules.required]" outlined required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">{{ $t("app.actions.add") }}</v-btn>
                  <v-btn variant="text" @click="closeAddSkillDialog">{{ $t("app.actions.cancel") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editSkillDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ $t("candidateTabs.skills.editTitle") }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="updateSkill">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field :label="`${$t('candidateTabs.skills.field')} *`" v-model="editSkill.Skill" :rules="[rules.required]" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select :items="yesNoOptions" item-title="title" item-value="value" :label="$t('candidateTabs.skills.mainQuestion')" v-model="editSkill.Main_skill" :rules="[rules.required]" outlined required></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field :label="`${$t('candidateTabs.skills.level')} *`" v-model="editSkill.Level" :rules="[rules.required]" outlined required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">{{ $t("app.actions.save") }}</v-btn>
                  <v-btn variant="text" @click="closeEditSkillDialog">{{ $t("app.actions.cancel") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

// Skills CRUD tab extracted from CandidateDetails.vue.
export default defineComponent({
  name: "CandidateSkillsTab",
  props: {
    candidateId: { type: [String, Number], required: true },
    items: { type: Array, default: () => [] },
  },
  emits: ["refresh", "notify"],
  data() {
    return {
      addSkillDialog: false,
      newSkill: { Skill: "", Main_skill: "", Level: "" },
      editSkillDialog: false,
      editSkill: { id: null, Skill: "", Main_skill: "", Level: "" },
    };
  },
  computed: {
    rules() {
      return { required: (value) => !!value || this.$t("candidateTabs.common.requiredField") };
    },
    yesNoOptions() {
      return [
        { title: this.$t("candidates.values.yes"), value: "Da" },
        { title: this.$t("candidates.values.no"), value: "Nu" },
      ];
    },
  },
  methods: {
    openAddSkillDialog() {
      this.newSkill = { Skill: "", Main_skill: "Nu", Level: "" };
      this.addSkillDialog = true;
    },
    closeAddSkillDialog() {
      this.addSkillDialog = false;
    },
    addSkill() {
      if (!this.newSkill.Skill.trim() || !this.newSkill.Level.trim()) {
        this.$emit("notify", { message: this.$t("candidateTabs.common.requiredEmpty"), color: "error" });
        return;
      }
      const payload = {
        id_foreign: this.candidateId,
        Skill: this.newSkill.Skill,
        Main_skill: this.newSkill.Main_skill === "Da",
        Level: this.newSkill.Level,
      };
      axios
        .post("/candidati/skills", payload)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.skills.added"), color: "success" });
          this.addSkillDialog = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la adăugarea abilității:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.skills.addError"), color: "error" });
        });
    },
    openEditSkillDialog(skill) {
      this.editSkill = { ...skill };
      this.editSkillDialog = true;
    },
    closeEditSkillDialog() {
      this.editSkillDialog = false;
    },
    updateSkill() {
      if (!this.editSkill.Skill.trim() || !this.editSkill.Level.trim()) {
        this.$emit("notify", { message: this.$t("candidateTabs.common.requiredEmpty"), color: "error" });
        return;
      }
      const skillId = this.editSkill.id;
      const payload = {
        id_foreign: this.candidateId,
        Skill: this.editSkill.Skill,
        Main_skill: this.editSkill.Main_skill === "Da",
        Level: this.editSkill.Level,
      };
      axios
        .put(`/candidati/skills/${skillId}`, payload)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.skills.updated"), color: "success" });
          this.editSkillDialog = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la actualizarea abilității:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.skills.updateError"), color: "error" });
        });
    },
    confirmDeleteSkill(id) {
      if (confirm(this.$t("candidateTabs.skills.deleteConfirm"))) {
        this.deleteSkill(id);
      }
    },
    deleteSkill(id) {
      axios
        .delete(`/candidati/skills/${id}`)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.skills.deleted"), color: "success" });
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la ștergerea abilității:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.skills.deleteError"), color: "error" });
        });
    },
  },
});
</script>
